import TourTypes from './types';

export const setTourRun = (run) => ({
  type: TourTypes.SET_TOUR_RUN,
  payload: run,
});

export const setTourStepIndex = (index) => ({
  type: TourTypes.SET_TOUR_INDEX,
  payload: index,
});
